// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import LinkedInPlus from "./assets/projects/LinkedInPlus.jpg";


// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Himanshu Joshi",
  tagline: "I build things for web",
  img: profile,
  p1:`• I am Mern full stack web devloper.`,
  p2:`• Knowledge Of MongoDB, Express.js, React.js, Node.js ,MVC Architecture.`,
  p3:`• Creative problem solver and specializing in resolving complex challenges to deliver efficient solutions.`,
  p4: `• I am confident that my academic background, coupled with my passion for web development, makes me a
valuable asset to your team`

};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/himanshu-joshi01/",
  github: "https://github.com/himanshu-joshi01",
  twitter: "https://x.com/Joshi_Himanshu_",
  instagram: "https://www.instagram.com/lazzie_coder/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "MERN Full stack development",
    Company: `Apna College`,
    Location: "ONLINE",
    Type: "E-Learning",
    Duration: "Sep 2023 - jan 2024",
  },
  {
    Position: "JAVA Data Structure and Algorithm",
    Company: `Apna College`,
    Location: "ONLINE",
    Type: "E-Learning",
    Duration: "Jan 2024 - April 2024",
  },

];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Master of Computer Application (MCA)",
    Company: `Lal bahadur shastri institue (LBSIMDS)`,
    Location: "Lucknow (U.P)",
    Type: "REGULAR",
    Duration: "2022 - 2024",
  },
  {
    Position: "Bachelor of Computer Application (BCA)",
    Company: `Babu banarasi das university (BBDU)`,
    Location: "Lucknow (U.P)",
    Type: "REGULAR",
    Duration: "2016 - 2019",
  },
  {
    Position: "Higher Secondary Education (12th)",
    Company: `Kendriya Vidyalaya Kanpur cantt`,
    Location: "Kanpur (U.P)",
    Type: "CBSE",
    Duration: "2014 - 2015",
  }, 
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "Atithi Devo Bhavo",
    image: projectImage1,
    description: `The website aimed to connect travelers with local hosts, promoting cultural exchange and authentic experiences.
Key features included user profiles, Feeds, Host Management System, Responsive Design, Social Sharing.`,
    techstack: "HTML, CSS, JavaScript, Express Js, MongoDB, MAP Api, Paasport Js ",
    previewLink: "https://atithi-devo-bhava.onrender.com",
    githubLink: "https://github.com/himanshu-joshi01/Atithi-Devo-Bhava",
  },
{
  title: "LinkedIn_Plus",
  image: LinkedInPlus,
  description: `LinkedIn is a business and employment-focused social media platform that operates through websites and mobile apps.`,
  techstack: "HTML, Tailwind, JavaScript, React Js , Axios, Netlify",
  previewLink: "https://linkedin-plus.netlify.app",
  githubLink: "https://github.com/himanshu-joshi01/LinkedIn_Plus",
},
  {
    title: "Shopcart",
    image: projectImage2,
    description: `Developed a fully functional E-commerce website, ShopCart. The website allows users to browse and purchase
products, manage their accounts, track orders and many other functionality .`,
    techstack: "HTML, CSS, JavaSCript, ReactJS, Redux, Material UI",
    previewLink: "https://google.com",
    githubLink: "https://github.com/himanshu-joshi01/Shopcart",
  },
  {
    title: "DSA DRIVE",
    image: projectImage3,
    description: `Developed a Data Structures and Algorithms (DSA) Tracker, a web application to help users track and improve
their coding skills. The platform allows users to practice and solve problems, track their progress, and compete
with others.`,
    techstack: "HTML, CSS, JavaScript, React Js",
    previewLink: "https://google.com",
    githubLink: "https://github.com/himanshu-joshi01/DSA_DRIVE",
  },
  {
    title: "Weather Web App",
    image: projectImage4,
    description: `A weather web app is a web-based application that provides current and forecasted weather conditions for a specific location or region`,
    techstack: "HTML,CSS, JavaScript, React Js, weather api, tailwind",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "himanshujoshi3110@gmail.com",
  Mobile: "+91 9369468394",
};
